// src/components/layout/Footer.js
import React from "react";
import { FaReact, FaHeart } from "react-icons/fa";
import { SiTailwindcss } from "react-icons/si";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white mt-auto">
      <div className="mx-auto max-w-7xl px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          {/* Brand Section */}
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <img src="/logo.png" alt="Review Market EU" className="h-8 w-8 object-contain" />
              <h3 className="font-bold text-lg">Review Market EU</h3>
            </div>
            <p className="text-sm text-gray-400">
              Earn money by sharing your honest reviews of restaurants, hotels, and gyms across Europe.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-3 text-primary-300">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/" className="hover:text-primary-400 transition-colors">Home</a></li>
              <li><a href="/wallet" className="hover:text-primary-400 transition-colors">Wallet</a></li>
              <li><a href="/refer" className="hover:text-primary-400 transition-colors">Referral Program</a></li>
              <li><a href="/contact" className="hover:text-primary-400 transition-colors">Contact Support</a></li>
            </ul>
          </div>

          {/* Tech Stack */}
          {/* <div>
            <h4 className="font-semibold mb-3 text-primary-300">Built With</h4>
            <div className="flex items-center gap-4 text-sm text-gray-400">
              <div className="flex items-center gap-2 hover:text-primary-400 transition-colors">
                <FaReact className="h-5 w-5 text-blue-400" />
                <span>React</span>
              </div>
              <div className="flex items-center gap-2 hover:text-primary-400 transition-colors">
                <SiTailwindcss className="h-5 w-5 text-cyan-400" />
                <span>Tailwind</span>
              </div>
            </div>
          </div> */}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">
            &copy; {currentYear} Review Market EU. All rights reserved.
          </p>
          <p className="text-sm text-gray-400 flex items-center gap-2">
            Made with <FaHeart className="h-4 w-4 text-red-500 animate-pulse" /> for reviewers
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
